(function ($) {
    $(document).ready(function () {
    });
})(jQuery); // Fully reference jQuery after this point.
